import { environment as env } from 'src/environments/environment';

/**
 * When true: Auth0 (`AuthModule`, `AuthGuard`, bearer via `@auth0/auth0-angular`).
 * When false: Keycloak (`KeycloakAngularModule`, `KeycloakService`, `KeycloakBearerInterceptor`).
 * Prefer explicit `useAuth0`; if omitted from an environment file, `authProvider === 'auth0'` is used.
 */
export function useAuth0Provider(): boolean {
  return (env as any)['useAuth0'] ?? true;
}